$( document ).ready(function() {
  
  var iframe = $("#iframevideo").attr('data-src');
  
  if(typeof iframe !== 'undefined'){
    const waypoints = [
      {
        id: 'iframevideo',
        handler(direction) { 
          var newsrc = $("#iframevideo").attr('data-src');
          $("#iframevideo").attr('src', newsrc );
          $("#iframevideo").removeAttr('data-src');
        }
      }
    ];

    waypoints.forEach(({ id, handler }) => (
      new Waypoint({
        element: document.getElementById(id),
        handler,
        offset: 20 // añade un margen superior opcional
      })
    ));
  }

   // Find the element with the class "variant-sku"
  const skuElement = $(".variant-sku");
  
  // Check if the element exists
  if (skuElement.length > 0) {
    // Read the SKU value
    const skuValue = skuElement.text();
    setTimeout(function() {
       $("#popup1 input#hidden-1").val(skuValue);
    }, 3000); // 2000 milliseconds = 2 seconds
  }  
  
});